import { RadioGroup, Stack, Text } from '@chakra-ui/react';
import { CustomPageOption } from 'constants/download';
import { Input, InputError } from 'modules/common/components/Input';
import { RadioOption } from 'modules/common/components/Radio/RadioOption';
import { RadioOptionBox } from 'modules/common/components/Radio/RadioOptionBox';
import { ChangeEvent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomPageOptionProps } from './DownloadModal.types';

export const CustomPageOptionSelect = ({
  customPageRangeOption,
  handleCustomPageRangeOption,
  handleCustomPageRangeInput,
  isValidRange,
}: CustomPageOptionProps) => {
  const { t } = useTranslation('common_navbar');

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    handleCustomPageRangeInput(e.target.value || '');
  };

  const handleClickRadio = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();

    // Find radio input
    const [option] = e.currentTarget.getElementsByTagName('input');

    if (option?.value) {
      handleCustomPageRangeOption?.(option?.value);
    }
  };

  const title = t('modals.download.title-select-pages');
  const optionAll = t('modals.download.option-all');
  const optionCustom = t('modals.download.option-custom');
  const inputError = t('pageRange.invalid-input-error');

  const inputLabel = 'Custom page range input';
  const inputErrorId = 'custom-page-range-error';

  return (
    <>
      <Text fontSize='sm' fontWeight='semibold' my='2'>
        {title}
      </Text>
      <RadioGroup mb='4' w='full' value={customPageRangeOption}>
        <Stack spacing={0}>
          <RadioOptionBox
            selected={CustomPageOption.All === customPageRangeOption}
            onClick={handleClickRadio}
            boxProps={{ paddingTop: 1, paddingBottom: 1 }}
          >
            <RadioOption value={CustomPageOption.All} borderColor={'gray.500'}>
              {optionAll}
            </RadioOption>
          </RadioOptionBox>
          <RadioOptionBox
            selected={CustomPageOption.Custom === customPageRangeOption}
            onClick={handleClickRadio}
            boxProps={{
              display: 'flex',
              lineHeight: 1,
              paddingTop: 1,
              paddingBottom: 1,
            }}
          >
            <RadioOption value={CustomPageOption.Custom} borderColor={'gray.500'}>
              {optionCustom}
            </RadioOption>
            <Input
              ml={2}
              w={120}
              size={'xs'}
              borderColor={'font.300'}
              borderRadius={'base'}
              errorBorderColor='red.600'
              onChange={handleChangeInput}
              isInvalid={!isValidRange}
              cursor='text'
              aria-label={inputLabel}
              aria-describedby={inputErrorId}
              _placeholder={{ bg: 'font.300' }}
            />
          </RadioOptionBox>
        </Stack>

        {!isValidRange && <InputError id={inputErrorId}>{inputError}</InputError>}
      </RadioGroup>
    </>
  );
};
